export const textToEmailArray = (text: string): string[] => {
  // the Set constructor removes duplicates
  return [...new Set(text.split(",").map((t) => t.trim().toLocaleLowerCase()))].filter((s) => !!s);
};
